<template>
  <div>
    <disease-list />
  </div>
</template>

<script>
import diseaseList from './list.vue'
export default {
  components: { diseaseList },
  data() {
    return {
    }
  },
  methods: {
  }
}
</script>

<style>
</style>

